import { FC } from "react";
import Container from "react-bootstrap/Container";
import { useLocation } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { reportVulnerabilitiesRoute } from "app/route/Routes";
import { Toolbar, ToolbarTitle } from "app/component/util/Toolbar";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { FormValues } from "app/component/report-vulnerability/ReportVulnerabilitiesTableFiltersForm";
import { PublishedReportVulnerabilitiesTable } from "app/component/report-vulnerability/PublishedReportVulnerabilitiesTable.tsx";

export type LocationState = {
    initialFilters: FormValues;
};

const isLocationState = (value: unknown): value is LocationState =>
    typeof value === "object" && value !== null && "initialFilters" in value;

export const AllReportVulnerabilitiesListScreen: FC = () => {
    const location = useLocation();

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVulnerabilitiesRoute} />
                <Toolbar>
                    <ToolbarTitle>
                        <h1>All report vulnerabilities</h1>
                    </ToolbarTitle>
                </Toolbar>
                <PublishedReportVulnerabilitiesTable
                    initialFilters={isLocationState(location.state) ? location.state.initialFilters : undefined}
                />
            </Container>
        </NavigationScreen>
    );
};
